import React from 'react';
import { Plus, Home } from 'lucide-react';
import PropertyCard from '../shared/PropertyCard';

const MobilePropertiesTab = ({ properties, onAddProperty, onPropertyClick }) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-sm font-semibold text-notion-text">All Properties</h2>
        <button onClick={onAddProperty} className="flex items-center gap-1 px-3 py-1.5 bg-stone-800 text-white rounded-lg text-xs font-medium shadow-sm">
          <Plus className="w-3.5 h-3.5" /> Add
        </button>
      </div>

      {(!properties || properties.length === 0) ? (
        <div className="bg-white border border-notion-border rounded-xl p-6 text-center">
          <Home className="w-8 h-8 text-stone-300 mx-auto mb-2" />
          <h3 className="text-sm font-medium text-stone-600 mb-1">No properties yet</h3>
          <p className="text-xs text-stone-400">Tap "Add" to create your first listing</p>
        </div>
      ) : (
        <div className="space-y-3">
          {properties.map((property) => (
            <PropertyCard
              key={property.id}
              property={property}
              onClick={onPropertyClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MobilePropertiesTab;
